import { z } from 'zod'

export const PurchaseParamsSchema = z.object({
    grossEUR: z.string(),
    grossUSD: z.string(),
    transactionId: z.string(),
    firstPurchase: z.boolean().default(false),
})

export type PurchaseParams = z.infer<typeof PurchaseParamsSchema>

export const LevelUpParamsSchema = z.object({
    level: z.number(),
})

export type LevelUpParams = z.infer<typeof LevelUpParamsSchema>

export const UpdateAvatarParamsSchema = z.union([
    z.object({ avatarId: z.number() }),
    z.object({ avatarBlob: z.instanceof(Blob) }),
])

export const StoryStepParamsSchema = z.object({
    label: z.string(),
})

export type StoryStepParams = z.infer<typeof StoryStepParamsSchema>

export type UpdateAvatarParams = z.infer<typeof UpdateAvatarParamsSchema>

export const UpdateNickParamsSchema = z.object({
    nick: z.string(),
})

export type UpdateNickParams = z.infer<typeof UpdateNickParamsSchema>

const playerOnlineEventSchema = z.object({
    eventName: z.literal('online'),
    payload: z.object({
        level: z.number(),
    }),
})

const levelUpdatedEventSchema = z.object({
    eventName: z.literal('level_updated'),
    payload: z.object({
        level: z.number(),
    }),
})

const questCompletedEventSchema = z.object({
    eventName: z.literal('quest_completed'),
    payload: z.object({
        questID: z.number(),
        questKey: z.string(),
    }),
})

const paymentCompletedEventSchema = z.object({
    eventName: z.literal('payment_completed'),
    payload: z.object({
        paymentOfferID: z.number(),
        paymentOfferKey: z.string(),
        paymentOfferType: z.number(),
        grossEUR: z.string(),
        grossUSD: z.string(),
        transactionId: z.string(),
        firstPurchase: z.boolean().default(false),
    }),
})

const placeOnSceneEventSchema = z.object({
    eventName: z.literal('place_on_scene'),
    payload: z.object({
        object_id: z.number(),
    }),
})

const moveToStorageEventSchema = z.object({
    eventName: z.literal('move_to_storage'),
    payload: z.object({
        item_id: z.number(),
    }),
})

export const GameEventSchema = z.discriminatedUnion('eventName', [
    playerOnlineEventSchema,
    levelUpdatedEventSchema,
    questCompletedEventSchema,
    paymentCompletedEventSchema,
    placeOnSceneEventSchema,
    moveToStorageEventSchema,
])

export type GameEvent = z.infer<typeof GameEventSchema>
